import isUndefined from 'lodash/isUndefined'
import React, {Children, Fragment} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import CustomPropTypes from '../../customPropTypes'
import * as pane from '../../store/pane'

import Source from '../Source'

export const getChildrenForViewportWidth = (arrayOfProps = [], viewportWidth = 0) => {
  const match = arrayOfProps
    // undefined minWidth becomes 0
    .map((p) => (isUndefined(p.minWidth) ? Object.assign({}, p, {minWidth: 0}) : p))
    // sort lowest minWidth first, highest minWidth last
    .sort((a, b) => a.minWidth > b.minWidth)
    // filter all that have a minWidth greater than the viewportWidth
    .filter((p) => p.minWidth <= viewportWidth)
    // get the last item
    .pop()

  return match ? match.children : null
}

const Resp = (props) => {
  const {children, viewportWidth} = props
  const arrayOfSourceProps = Children.toArray(children)
    .filter(Source.isSource)
    .map((s) => s.props)
  const childrenForViewportWidth = getChildrenForViewportWidth(arrayOfSourceProps, viewportWidth)

  return <Fragment>{childrenForViewportWidth}</Fragment>
}

Resp.propTypes = {
  children: CustomPropTypes.children,
  viewportWidth: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => ({viewportWidth: pane.viewportWidth(state)})

export default connect(mapStateToProps)(Resp)
